module.exports = __webpack_public_path__ + "static/Shreyas_P_S-4a8238136283309c641e5f048b46c068.jpeg";